/** Mask a secret: hide everything but the last 4 chars. */
export function maskSecret(value) {
    if (!value)
        return '';
    if (value.length <= 4)
        return '•'.repeat(value.length);
    return `${'•'.repeat(Math.min(value.length - 4, 12))}${value.slice(-4)}`;
}
